/**
 * Calculates the number of days between two date strings.
 *
 * @param start - The start date as an ISO string or `null`.
 * @param end - The end date as an ISO string or `null`.
 * @returns The number of days between the start and end dates, rounded to the nearest integer,
 *          or `null` if either date is not provided.
 */
export const calculateDaysBetween = (
  start?: string,
  end?: string
): number | null => {
  if (!start || !end) return null;

  const startDate = new Date(start);
  const endDate = new Date(end);

  const diffInMs = endDate.getTime() - startDate.getTime();
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

  return Math.round(diffInDays);
};
